import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './styles.css';

const imgWithClick = { cursor: 'pointer' };

const PhotoGalleryItem = ({
  index,
  onClick,
  onDelete,
  photo,
  direction,
  top,
  left,
  controls = false,
  draggable = false,
}) => {
  const imgStyle = {
    margin: '0',
    border: '3px solid transparent',
    cursor: 'move',
  };

  if (direction === 'column') {
    imgStyle.position = 'absolute';
    imgStyle.left = left;
    imgStyle.top = top;
  }

  const handleClick = event => {
    onClick(event, { photo, index });
  };

  const handleDelete = () => {
    !photo.disabled && onDelete(photo.id);
  };

  return (
    <figure
      className={
        draggable
          ? 'photo-gallery-item photo-gallery-item--draggable'
          : 'photo-gallery-item'
      }
      style={onClick ? { ...imgStyle, ...imgWithClick } : imgStyle}
    >
      <img
        className="photo-gallery-item__image"
        {...photo}
        onClick={onClick ? handleClick : null}
        alt="img"
      />
      {controls && (
        <figcaption className="photo-gallery-item__figcaption">
          <a className="photo-gallery-item__link" onClick={handleDelete}>
            <FontAwesomeIcon icon={faTimes} size="xs" />
          </a>
        </figcaption>
      )}
    </figure>
  );
};

export default PhotoGalleryItem;
